import { GameFormProps } from '@/components/GameForm';
import { cleanURLQueryParams, URLCleanModes } from './GameQueryParamsCleaner';

export default class GameFormQueryParamsParser {
  gameFormProps: GameFormProps;
  queryKey: string;

  constructor(gameFormProps: GameFormProps) {
    this.gameFormProps = gameFormProps;
    this.queryKey = '__gamedata';
  }

  init() {
    const search = new URLSearchParams(window.location.search);
    const value = search.get(this.queryKey);
    if (value) {
      this.gameState(value);
    }
  }

  private gameState: (queryParamValue: string) => void = (
    queryParamValue: string
  ) => {
    try {
      const gameData = JSON.parse(queryParamValue);

      if (gameData && this.gameFormProps.onStateUpdate) {
        this.gameFormProps.onStateUpdate(gameData);
      }

      cleanURLQueryParams(URLCleanModes.PUSH);
    } catch {
      console.warn('No proper game data from url params');
    }
  };
}
